export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const fetchSettingAction = (settings) => {
  return {
    type: "FETCH_SETTINGS",
    payload: settings,
  };
};
